import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import Footer from './Footer';

interface LanguageWrapperProps {
  children: React.ReactNode;
}

const LanguageWrapper = ({ children }: LanguageWrapperProps) => {
  const { lang } = useParams<{ lang: string }>();
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (lang && (lang === 'dk' || lang === 'en')) {
      i18n.changeLanguage(lang);
      localStorage.setItem('language', lang);
    } else if (!lang || (lang !== 'dk' && lang !== 'en')) {
      const savedLang = localStorage.getItem('language') || 'dk';
      navigate(`/${savedLang}`, { replace: true });
    }
  }, [lang, i18n, navigate]);

  // Show nothing while redirecting
  if (!lang || (lang !== 'dk' && lang !== 'en')) {
    return null;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};

export default LanguageWrapper;
